import { Container, Divider, Paper, Stack, Typography } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";

export default function TermsOfService() {
  const { t, i18n } = useTranslation();
  return (
    <Container disableGutters style={{margin:"auto"}}>
      <Stack component={Paper} spacing={2} sx={{p: 4}}>
        <Typography color="primary" fontSize="large">Terms of Service</Typography>
        <Divider/>
        <Typography><Trans t={t}>
          The website of nice2win.com provides interface to the Smart
          Contract on the Optimism blockchain, which accepts ETH tokens and
          transfers varying amounts of ETH tokens in return, depending on
          external factors. We are not able to verify the legality of the
          service in each jurisdiction and provide you with any legal advice. It
          is your sole responsibility to comply with any relevant laws, policies
          and regulations of your jurisdiction regarding the use of ETH tokens
          in the way described above. Playing the games offered by the Smart
          Contract can lead to obtainment or loss of ETH tokens. We do not hold 
          any responsibility for the results of the games we provide. We reserve
          the right to modify the website and its services and these terms
          without any prior notice. We advise to check for updates on regular
          basis.</Trans>
        </Typography>
      </Stack>
    </Container>
  );
}
